<template>
  <div class="map-layer-manager">
    <div class="map-layer-manager-title">
      <i class="el-icon-s-operation"></i>
      <span>图层管理</span>
      <i class="el-icon-close" 
         style="position: absolute; right: 15px; cursor: pointer;" 
         @click="$emit('close')"></i>
    </div>
    <div class="map-layer-manager-content">
      <div class="map-layer-group">
        <div>
          <h4 class="map-layer-group-title">基础底图</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.tianditu }" 
                 @click="$emit('switch-layer', $event)" 
                 title="tianditu">天地图</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.dixingtu }" 
                 @click="$emit('switch-layer', $event)" 
                 title="dixingtu">地形图</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.weixingtu }" 
                 @click="$emit('switch-layer', $event)" 
                 title="weixingtu">卫星图</div>
          </div>
        </div>
      </div>

      <div class="map-layer-group">
        <div>
          <h4 class="map-layer-group-title">叠加图层</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.haitu }" 
                 @click="$emit('switch-layer', $event)" 
                 title="haitu">海图</div>
          </div>
        </div>
      </div>
      
      <div class="map-layer-group">
        <div>
          <h4 class="map-layer-group-title">船舶图层</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.ship }" 
                 @click="$emit('switch-layer', $event)" 
                 title="ship">船舶</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.radarTarget }" 
                 @click="$emit('switch-layer', $event)" 
                 title="radarTarget">雷达目标</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.leishenTarget }" 
                 @click="$emit('switch-layer', $event)" 
                 title="leishenTarget">激光目标</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.aisRadar }" 
                 @click="$emit('switch-layer', $event)" 
                 title="aisRadar">AIS雷达融合</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.radarLine }" 
                 @click="$emit('switch-layer', $event)" 
                 title="radarLine">雷达尾迹</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.shipWarn }" 
                 @click="$emit('switch-layer', $event)" 
                 title="shipWarn">船舶预警</div>
          </div>
        </div>
      </div>
      
      <div class="map-layer-group" style="display: none;">
        <div>
          <h4 class="map-layer-group-title">桥梁防撞</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridge }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridge">桥梁</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeReport }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeReport">桥梁报告线</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeChannel }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeChannel">通航航道</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeNavigation }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeNavigation">通航区</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeWarn }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeWarn">警戒区</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeForbid }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeForbid">禁航区</div>
          </div>
        </div>
      </div>
      
      <div class="map-layer-group" style="display: none;">
        <div>
          <h4 class="map-layer-group-title">设备管理</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.cctv }" 
                 @click="$emit('switch-layer', $event)" 
                 title="cctv">CCTV</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.box }" 
                 @click="$emit('switch-layer', $event)" 
                 title="box">智能箱</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.laser }" 
                 @click="$emit('switch-layer', $event)" 
                 title="laser">激光</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.radar }" 
                 @click="$emit('switch-layer', $event)" 
                 title="radar">雷达</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.relay }" 
                 @click="$emit('switch-layer', $event)" 
                 title="relay">网络继电器</div>
          </div>
        </div>
      </div>
      
      <div class="map-layer-group"  style="display: none;">
        <div>
          <h4 class="map-layer-group-title">其它</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.hxjg }" 
                 @click="$emit('switch-layer', $event)" 
                 title="hxjg">航行警告</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.bridgeMast }" 
                 @click="$emit('switch-layer', $event)" 
                 title="bridgeMast">桥柱</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.shipTracks }" 
                 @click="$emit('switch-layer', $event)" 
                 title="shipTracks">船舶航迹</div>
            <div class="map-layer-item" 
                 :class="{ active: layerStatus.warningAreas }" 
                 @click="$emit('switch-layer', $event)" 
                 title="warningAreas">警戒区域</div>
          </div>
        </div>
      </div>
      
      <!-- 临时调试：防重叠开关 -->
      <div class="map-layer-group">
        <div>
          <h4 class="map-layer-group-title">调试</h4>
          <div class="map-layer-list">
            <div class="map-layer-item" 
                 :class="{ active: antiOverlapEnabled }" 
                 @click="$emit('toggle-anti-overlap')"
                 title="antiOverlap">标注防重叠</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayerManager',
  props: {
    layerStatus: {
      type: Object,
      required: true
    },
    antiOverlapEnabled: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
/* 图层管理器样式 */
.map-layer-manager {
  position: absolute;
  z-index: 1200;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
  width: 380px;
  max-height: calc(100vh - 100px); /* 增加图层管理器的最大高度 */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  top: 60px;
  right: 10px;
}

.map-layer-manager-title {
  padding: 10px 15px;
  background-color: #f0f2f5;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  font-weight: 500;
  user-select: none;
  position: relative;
}

.map-layer-manager-title i {
  margin-right: 8px;
  font-size: 16px;
  color: #606266;
}

.map-layer-manager-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
  max-height: calc(100vh - 150px); /* 增加内容区的最大高度 */
}

.map-layer-group {
  margin-bottom: 10px;
}

.map-layer-group-title {
  padding: 0 15px;
  margin: 5px 0;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.map-layer-list {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 10px;
}

.map-layer-item {
  margin: 3px 5px;
  padding: 4px 8px;
  background-color: #f4f4f5;
  color: #909399;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.map-layer-item:hover {
  background-color: #e9e9eb;
}

.map-layer-item.active {
  background-color: #409EFF;
  color: white;
}
</style> 